<template>
  <div class="lh-15 c-333">
    <ProductBanner
      is-fixed
      is-scroll
      :banner-img="bannerImg"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
      :product-name="$t('common.productName.autoKit')"
      :custom-style="{ bottom: '2.44rem', left: '2rem' }"
      :main-title="$t('products.autoKit.bannerTitle')"
      :sub-title="$t('products.autoKit.subTitle')"
      :slogan="$t('products.autoKit.bannerDesc')"
    >
      <div slot="dealer" class="banner-btn d-ib ta-c cu-p" @click="showQuotePopup = true">
        {{ $t('common.common.ContactUs') }}
      </div>
    </ProductBanner>
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor
        is-show-function
        is-show-accessories
        is-show-resource
        :product-name="$t('common.productName.autoKit')"
        :spec-url="'/product/autosteeringspecs'"
        spec-title="SPECs"
      >
        <div
          slot="rigthbtn"
          @click="showQuotePopup = true"
          class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc free-quote cu-p"
        >
          Free Quote
        </div>
      </NavAnchor>

      <IconWrap bgc="bgc-FCFCFC" :icon-wrap-data="iconWrapData" is-show-tip id="overview" />
      <!--area-2  -->
      <section class="area-2">
        <div class="pt-160 w-1200r m-a d-f p-r jc-sb">
          <div class="img-box p-r">
            <img
              class="lazy-image"
              v-lazy="require('@/assets/images/autosteeringkit0920//area-2.jpg')"
              width="100%"
              height="100%"
              alt="Hands-Free and More Productive"
            />
            <i
              @click="area2VideoModal = !area2VideoModal"
              class="play-icon play-icon-fff d-b p-a c-c z-3 c-p"
              data-v-youtube-src="//www.youtube.com/embed/0QziljQLrK0"
            ></i>
          </div>
          <div class="text-box">
            <h2 class="c-333 fs-48 mb-32">Hands-Free and More Productive</h2>
            <div class="desc">
              <p>
                FJD AT1 Autosteering Kit uses GNSS and RTK to navigate tractors along straight lines, curves, or
                concentric circles with sub-inch (2.5cm) accuracy.
              </p>
              <br class="in-pc" />
              <p>This auto steer works with a wide array of tractors, harvesters, and other agricultural machines.</p>
            </div>
            <div class="area-2-btn ta-c">
              <a
                class="d-ib"
                target="_blank"
                href="https://fj-fjdynamics-storage-01-1304943718.cos.ap-shanghai.myqcloud.com/FJD%20Autosteering%20Kit%202022.pdf"
                >Download AT1 Brochure</a
              >
            </div>
          </div>
        </div>
      </section>
      <Application :app-h2="$t('products.autoKit.area3H2')" :application-data="applicationData" />
      <!-- 轮播 -->
      <VerticalCarousel
        id="function"
        carousel-h3="Functions"
        :swiper-option="area5SwiperOption"
        :swiper-data="swiperData"
      />
      <!-- 左右图文结构 -->
      <ImgDesc id="features" :is-reverse="1" :main-title="mainTitle" :img-desc-data="imgDescData" class="pt-160" />
      <!-- 左右切换轮播 -->
      <leftRightCarousel
        :swiper-option="leftRightswiperOption"
        :active-index="activeIndex"
        :swiper-data="leftRightswiperData"
        :title="leftRightSwiperTitle"
        :desc-style="descStyle"
        :sub-title="leftRightSwiperSubTitle"
      />
      <!-- 常规轮播 -->
      <Carousel
        id="accessories"
        :carousel-wrap="{ width: '8.96rem', margin: '0 auto' }"
        :pagination-style="{ top: '4.26rem' }"
        :wrapper-style="{ width: '7.44rem', height: '4.2rem', margin: ' 0 auto 1.2rem auto' }"
        ref="carousel"
        :title="carouselTitle"
        :swiper-option="swiperOption"
        :swiper-data="swiperCarouseData"
      />
      <!-- BUY NOW -->
      <section class="area-buy bgs-cover lazy-image p-r">
        <img width="100%" height="100%" v-lazy="require('@/assets/images/autosteeringkit0920/buy-bg.jpg')" alt="" />
        <div class="d-f fd-c jc-c h-100p p-a but-now-connent">
          <h2 class="ta-c c-fff">Get Your FJD AT1 Autosteering Kit</h2>
          <a
            href="https://store.fjdynamics.com/products/autosteeringkit"
            target="_blank"
            class="area-buy-btn c-fff d-ib m-a fs-16"
            ><span class="d-ib va-m">BUY NOW</span><i class="d-ib va-m triangle-icon triangle-icon-fff"></i
          ></a>
        </div>
      </section>

      <!-- 客户案例 -->
      <CustomerCard id="resource" :customer-data="customerData" />
      <!-- blog -->
      <BlogCard :blog-data="blogData" class="blog-wrap" />

      <Modal v-model="area2VideoModal" footer-hide width="60" class-name="area2-modal">
        <div slot="close">
          <svg-icon icon-class="video-close-white" class-name="close"></svg-icon>
        </div>
        <iframe
          width="100%"
          height="100%"
          src="//www.youtube.com/embed/0QziljQLrK0"
          frameborder="0"
          allow="autoplay"
          allowfullscreen=""
        ></iframe>
      </Modal>

      <!-- 留资弹窗 -->
      <Modal v-model="showQuotePopup" footer-hide width="800" class-name="dealer-modal">
        <div slot="close">
          <svg-icon icon-class="video-close-white" class-name="close"></svg-icon>
        </div>

        <AutoKitDealerForm is-auto-kit :base-info="isBaseInfo" />
      </Modal>

      <!-- showQuotePopup -->
    </div>
  </div>
</template>

<script>
  import bannerScroll from '@/mixins/bannerScroll.js'
  import AutoKitDealerForm from '@/components/AutoKitDealerForm'
  import bannerImg from '@/assets/images/autosteeringkit0920/banner.jpg'
  // import area2Img from ''

  import bannerProductImg from '@/assets/images/autosteeringkit0920/banner-pic.png'
  import area61img from '@/assets/images/autosteeringkit0920/area-6-1.jpg'
  import area62img from '@/assets/images/autosteeringkit0920/area-6-2.jpg'
  import area63img from '@/assets/images/autosteeringkit0920/area-6-3.jpg'

  import leftRightSwiper1img from '@/assets/images/autosteeringkit0920/area-7-1.jpg'
  import leftRightSwiper2img from '@/assets/images/autosteeringkit0920/area-7-2.jpg'
  import leftRightSwiper3img from '@/assets/images/autosteeringkit0920/area-7-3.jpg'
  import leftRightSwiper4img from '@/assets/images/autosteeringkit0920/area-7-4.jpg'
  import leftRightSwiper5img from '@/assets/images/autosteeringkit0920/area-7-5.jpg'
  import leftRightSwiper6img from '@/assets/images/autosteeringkit0920/area-7-6.jpg'
  import leftRightSwiper7img from '@/assets/images/autosteeringkit0920/area-7-7.jpg'
  import leftRightSwiper8img from '@/assets/images/autosteeringkit0920/area-7-8.jpg'
  import leftRightSwiper9img from '@/assets/images/autosteeringkit0920/area-7-9.jpg'
  import leftRightSwiper10img from '@/assets/images/autosteeringkit0920/area-7-10.jpg'
  import leftRightSwiper11img from '@/assets/images/autosteeringkit0920/area-7-11.jpg'

  // 常规轮播 图片
  import swiperarea8img1 from '@/assets/images/autosteeringkit0920/area-8-1.png'
  import swiperarea8img2 from '@/assets/images/autosteeringkit0920/area-8-2.png'

  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import Application from '@/components/Application'
  import ImgDesc from '@/components/ImgDesc'
  import VerticalCarousel from '@/components/Carousel/VerticalCarousel'
  import leftRightCarousel from '@/components/Carousel/leftRightCarousel'
  import Carousel from '@/components/Carousel/Carousel'
  import CustomerCard from '@/components/CustomerCard'
  import BlogCard from '@/components/BlogCard'

  // import CustomerCard from '@/components/CustomerCard'
  // import BlogCard from '@/components/BlogCard'

  const area5TabItem = [
    'products.autoKit.area4Tab1',
    'products.autoKit.area4Tab2',
    'products.autoKit.area4Tab3',
    'products.autoKit.area4Tab4',
    'products.autoKit.area4Tab5',
    'products.autoKit.area4Tab6',
    'products.autoKit.area4Tab7',
    'products.autoKit.area4Tab8'
  ]

  const carouseTabItem = ['FJD Satellite Navigation Base Station', 'FJD Wi-Fi Camera']

  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      // videoWrap,
      Application,
      VerticalCarousel,
      ImgDesc,
      leftRightCarousel,
      Carousel,
      CustomerCard,
      BlogCard,
      AutoKitDealerForm
    },
    mixins: [bannerScroll],
    data() {
      const vm = this

      return {
        bannerImg,
        bannerProductImg,
        showQuotePopup: false,
        isBaseInfo: false,
        // area2Img,
        area2VideoModal: false,
        iconWrapData: [
          {
            icon: 'isobus',
            vHtml: 'products.autoKit.icon1'
          },
          {
            icon: 'gis',
            vHtml: 'products.autoKit.icon2'
          },
          {
            icon: 'nmea',
            vHtml: 'products.autoKit.icon3'
          },
          {
            icon: 'u-turn',
            vHtml: 'products.autoKit.icon4'
          },
          {
            icon: 'terrain',
            vHtml: 'products.autoKit.icon5'
          },
          {
            icon: 'eye',
            vHtml: 'products.autoKit.icon6'
          },
          {
            icon: 'remote-control',
            vHtml: 'products.autoKit.icon7'
          },
          {
            icon: 'ota',
            vHtml: 'products.autoKit.icon8'
          }
        ],
        applicationData: [
          {
            imgUrl: require('@/assets/images/autosteeringkit0920/area-4-1.jpg'),
            imgDesc: 'products.autoKit.area3Img1'
          },
          {
            imgUrl: require('@/assets/images/autosteeringkit0920/area-4-2.jpg'),
            imgDesc: 'products.autoKit.area3Img2'
          },
          {
            imgUrl: require('@/assets/images/autosteeringkit0920/area-4-3.jpg'),
            imgDesc: 'products.autoKit.area3Img3'
          },
          {
            imgUrl: require('@/assets/images/autosteeringkit0920/area-4-4.jpg'),
            imgDesc: 'products.autoKit.area3Img4'
          }
        ],
        area5SwiperOption: {
          el: '',
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          autoplay: { delay: 3000 },
          pagination: {
            el: ' .vertical-swiper-style .vertical-swiper-pagination ul',
            clickable: true,
            renderBullet(index, className) {
              return (
                '<li class="' +
                className +
                '"><div class="pagination-item">' +
                vm.$t(area5TabItem[index]) +
                '</div></li>'
              )
            }
          }
        },
        swiperData: [
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-1.jpg'),
            desc: 'products.autoKit.area4Desc1'
          },
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-2.jpg'),
            desc: 'products.autoKit.area4Desc2'
          },
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-3.jpg'),
            desc: 'products.autoKit.area4Desc3'
          },
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/66579ad3387702306552419646/ZOsH9ZRhcNcA.mp4',
            poster: require('@/assets/images/autosteeringkit0920/fun-2-Modes.jpg'),
            desc: 'products.autoKit.area4Desc4'
          },
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-5.jpg'),
            desc: 'products.autoKit.area4Desc5'
          },
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-6.jpg'),
            desc: 'products.autoKit.area4Desc6'
          },
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-7.jpg'),
            desc: 'products.autoKit.area4Desc7'
          },
          {
            imgSrc: require('@/assets/images/autosteeringkit0920/area-5-8.jpg'),
            desc: 'products.autoKit.area4Desc8'
          }
        ],
        mainTitle: 'products.autoKit.area5H2',
        imgDescData: [
          {
            imgSrc: area61img,
            title: 'products.autoKit.area5Title1',
            desc: 'products.autoKit.area5Desc1'
          },
          {
            imgSrc: area62img,
            title: 'products.autoKit.area5Title2',
            desc: 'products.autoKit.area5Desc2'
          },
          {
            imgSrc: area63img,
            title: 'products.autoKit.area5Title3',
            desc: 'products.autoKit.area5Desc3'
          }
        ],
        activeIndex: 0,
        descStyle: {
          bottom: '0.64rem'
        },
        leftRightswiperOption: {
          loop: true,
          slidesPerView: 2.1, // 此值可以控制箭头左右距离
          spaceBetween: 16,
          centeredSlides: true,
          effect: 'slide',
          autoplay: 3700,
          pagination: {
            el: '.swiper-pagination-wrapper',
            type: 'fraction',
            clickable: true
          },
          //  加上 navigation 不然会出现左右点击事件失效
          navigation: {
            nextEl: ' .swiper-button-next',
            prevEl: ' .swiper-button-prev'
          },
          on: {
            slideChange() {
              console.log(this.realIndex, 'this.realIndex')
              vm.activeIndex = this.realIndex
            }
          }
        },
        leftRightSwiperTitle: 'Extensive Compatibility',
        leftRightSwiperSubTitle:
          'FJD AT1 is compatible with tractors, harvesters, and other agricultural machinery of multiple brands.',
        leftRightswiperData: [
          {
            imgSrc: leftRightSwiper1img,
            desc: 'Valtra N134'
          },
          {
            imgSrc: leftRightSwiper2img,
            desc: 'massey ferguson'
          },
          {
            imgSrc: leftRightSwiper3img,
            desc: 'John Deere WTS 9580i'
          },
          {
            imgSrc: leftRightSwiper4img,
            desc: 'Mercedes Benz Trac 1000'
          },
          {
            imgSrc: leftRightSwiper5img,
            desc: 'John Deere 8110'
          },
          {
            imgSrc: leftRightSwiper6img,
            desc: 'New Holland CR9060'
          },
          {
            imgSrc: leftRightSwiper7img,
            desc: 'CASE IH 2388'
          },
          {
            imgSrc: leftRightSwiper8img,
            desc: 'John Deere 8410T'
          },
          {
            imgSrc: leftRightSwiper9img,
            desc: 'CLAAS AXION 810'
          },
          {
            imgSrc: leftRightSwiper10img,
            desc: 'CASE 185'
          },
          {
            imgSrc: leftRightSwiper11img,
            desc: 'CLAAS ARION 530'
          }
        ],
        carouselTitle: 'Accessories',
        swiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              return '<span style="width:50%" class="' + className + '">' + vm.$t(carouseTabItem[index]) + '</span>'
            }
          },
          on: {
            init() {
              vm.$refs.carousel.$refs.swiperLine.style.width = `50%`
            },
            slideChange() {
              const index = this.realIndex
              // console.log('[ vm.$refs ] >', vm.$refs)
              // vm.$refs.carousel.$refs.swiperLine.style.width = `50%`
              vm.$refs.carousel.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
              // const curPlayVideo = vm.videos[index]
              // curPlayVideo.play()
            }
          }
        },
        swiperCarouseData: [
          {
            img: swiperarea8img1,
            desc: 'Provides real-time correctional info, so your agri-machines can achieve centimeter-level precision. '
          },
          {
            img: swiperarea8img2,
            desc: 'Sends real-time footage (1080P) to the control terminal from as far away as 20 meters, even at night (infrared night vision enabled).'
          }
        ],
        customerData: [
          {
            h2: 'Drew — A farmer in South Africa',
            desc: 'In the traditional farming model, we waste a lot of seeds and fertilizers, and sometimes we also waste some land. this auto steer kit from FJDynamics solves the problem of waste.',
            imgUrl: require('@/assets/images/autosteeringkit0920/customers_v1_cover.jpg'),
            videoUrl:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/a4588b15387702297354863321/RGFaOSvG37sA.mp4'
          },
          {
            h2: 'Nikola — A farmer from Serbia',
            desc: "This auto steer kit makes my work easier. I can work at night and find the boundaries of the fields. Some fields are up to 800 meters long. If I didn't have the help of this kit, I would never be able to walk straight.",
            imgUrl: require('@/assets/images/autosteeringkit0920/customers_v2_cover.jpg'),
            videoUrl:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e0a4d79f387702297355114989/huE6JCGp3VkA.mp4'
          },
          {
            h2: 'Adriaan — A farmer from Northern Ireland',
            desc: 'I use FJD autosteering kit to avoid spraying twice at places. This saves me about ＄2000 on my 200-hafarmland.',
            imgUrl: require('@/assets/images/autosteeringkit0920/customers_v3_cover.jpg'),
            videoUrl:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/de85f7b3387702297355044921/AWwdlQNXzZwA.mp4'
          }
        ],
        blogData: []
      }
    },
    head() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org/',
              '@type': 'ItemPage',
              '@graph': [
                {
                  '@type': 'Product',
                  name: 'FJD Autosteering Kit',
                  url: 'https://www.fjdynamics.com/product/autosteeringkit',
                  image: 'https://www.fjdynamics.com/images/nav0526/nav_1904.png',
                  description:
                    'FJD autosteering kit for the tractor is a high-accuracy GPS auto-guidance and steering system.',
                  brand: {
                    '@type': 'Brand',
                    name: 'FJDynamics'
                  },
                  review: [
                    {
                      '@type': 'Review',
                      reviewBody: 'Accurate enough and affordable auto steer for tractor',
                      reviewRating: {
                        '@type': 'Rating',
                        ratingValue: '4.5',
                        bestRating: '5'
                      },
                      author: {
                        '@type': 'Person',
                        name: 'Julien'
                      }
                    }
                  ]
                },
                {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: 'https://www.fjdynamics.com'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: 'Product',
                      item: 'https://www.fjdynamics.com/product'
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: 'Auto Steer for Tractor'
                    }
                  ]
                }
              ]
            }
          }
        ],
        title: 'GPS Guidance Auto Steer System for Tractor – FJDynamics',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'auto steer for tractor, auto steer, tractor gps'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJD auto steer system for tractor with GPS guidance, widely used in precision agriculture. Equipped with GNSS + RTK, high navigation accuracy of 2.5cm.'
          }
        ]
      }
    },
    created() {},
    mounted() {
      console.log('[ this.cancel ] >', this.cancel)
      // this.cancel = true
      this.createAnim()

      this.processProductIdBlog()
    },
    methods: {
      async processProductIdBlog() {
        // getProductIdBlog
        const { data } = await this.$api.blogApi.getProductIdBlog({
          languageCode: 'en-US',
          productId: '1'
        })
        this.blogData = data
      }
    }
  }
</script>

<style scoped lang="scss">
  .content {
    margin-top: 8.76rem;
  }
  .free-quote {
    margin-left: 0.8rem;
  }
  :deep(.banner-product-img) {
    width: 7.06rem;
    height: 3.67rem;
    top: 3.91rem;
    right: 6.45rem;
  }
  /* area-2 */
  .area-2 .img-box {
    width: 7.44rem;
    height: 4.19rem;
  }
  .area-2 .img-box::after {
    display: block;
    transition: opacity 0.3s linear;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .area-2 .img-box:hover::after {
    opacity: 0;
  }
  .area-2 .text-box {
    width: 4.24rem;
    margin-left: 0.32rem;
  }
  .area-2-btn {
    padding-top: 0.32rem;
  }
  .area-2-btn a {
    line-height: 0.56rem;
    padding: 0 0.24rem;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.9);
  }
  .area-2-btn a:hover {
    background-color: rgba(0, 0, 0, 0.85);
  }
  :deep(.area2-modal) {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }

    .ivu-modal-body {
      padding: 0;
      height: 70vh;
    }
    .ivu-modal-content {
      background: #000;
      box-sizing: border-box;
      // overflow: hidden;
    }
    .ivu-modal-close {
      top: -30px;
      right: -30px;
    }
  }
  // :deep(.ivu-modal-body) {
  //   padding: 0;
  //   height: 70vh;
  // }
  // :deep(.ivu-modal-content) {
  //   background: #000;
  //   box-sizing: border-box;
  //   // overflow: hidden;
  // }
  // :deep(.ivu-modal-close) {
  //   top: -30px;
  //   right: -30px;
  // }
  .close {
    width: 30px;
    height: 30px;
  }
  // area-buy
  .area-buy {
    height: 2.8rem;
    // margin-bottom: 1.6rem;
    // background-image: url('@/assets/images/autosteeringkit0920/buy-bg.jpg');
  }
  .area-buy h2 {
    font-size: 0.42rem;
  }
  .area-buy-btn {
    margin-top: 0.24rem;
    line-height: 0.36rem;
    padding: 0 0.12rem 0 0.24rem;
    box-sizing: border-box;
    border: 1px solid #fff;
    transition: all 0.3s linear;
  }
  .area-buy-btn:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.1);
  }
  .area-buy-btn .triangle-icon {
    width: 0.18rem;
    height: 0.18rem;
    transform: rotate(-90deg);
    margin-left: 0.12rem;
  }

  :deep(.customer-wrap) {
    padding-top: 1.6rem;
  }
  .but-now-connent {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .banner-btn {
    margin-top: 0.32rem;
    font-size: 0.24rem;
    line-height: 0.52rem;
    color: rgba(0, 0, 0, 0.85);
    background: rgba(255, 255, 255, 0.65);
    transition: background-color 0.3s linear;
  }
  .banner-btn:hover {
    background: rgba(255, 255, 255, 0.75);
  }

  :deep(.dealer-modal) {
    // :deep(.ivu-modal-content){
    .ivu-modal-body {
      padding: 30px 50px 30px 20px;
      border-radius: 12px;
    }
    .information-form {
      // width: 534px;
      // height: 730px;
      margin: 0;
      & .ivu-form .ivu-form-item-label {
        line-height: 35px;
        height: 35px;
      }
      & .ivu-form-item .ivu-input {
        height: 35px;
        width: 550px;
        font-size: 14px;
        display: inline-block;
        box-sizing: border-box;
        padding: 0 40px 0 10px;
        color: #666;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #dbdbda;
      }
      .message-input {
        & .ivu-input {
          height: 70px;
        }
      }

      & .ivu-input-type-textarea textarea {
        height: 126px;
      }
    }
    .ivu-select-single .ivu-select-selection {
      line-height: 35px;
      height: 35px;
      width: 550px;
      border: 1px solid #dbdbda;
    }
    .ivu-form-item {
      margin-bottom: 0.2rem;
    }
    .ivu-cascader-menu {
      // width: 100%;
      // width: 275px;
      overflow-x: hidden;
    }
    .ivu-cascader {
      width: 550px;
    }
    .ivu-cascader-label {
      line-height: 35px;
      height: 35px;
    }
    .ivu-select-dropdown-list {
      width: 533px;
    }
    // .ivu-cascader-menu

    // }
  }
  // .blog-wrap {
  //   padding-bottom: 1.6rem;
  // }
  // .area8-wrap {
  //   width: 8.96rem;
  //   margin: 0 auto;
  // }
  // .area-8-swiper {
  //   width: 8.96rem;
  //   margin: 0 auto;
  // }
</style>
